import {
  UPDATE_SEARCH,
  UPDATE_ENTRIES,
  PUSH_DETAILS,
  POP_DETAILS,
  CLEAR_DETAILS,
  CLEAR_ENTRIES,
  CLEAR_SEARCH,
  SET_SERVER_INSTANCE,
  SET_CERTIFICATE_TYPE,
  SET_CERTIFICATE_LABEL,
  SET_LOGPAGE_NUM,
  SET_RECENT_ENTRY,
  SET_SELECTED_AUTHORITY,
  SET_REQUEST_MESSAGE,
  SET_PROCESSING_STATE
} from "../actionTypes/actionTypes";


const updateSearch = (model) => {
  return {
    type: UPDATE_SEARCH,
    payload: model
  };
};

const updateEntries = (data) => {
  return {
    type: UPDATE_ENTRIES,
    payload: data
  };
};

const pushDetails = (entry) => {
  return {
    type: PUSH_DETAILS,
    payload: entry
  };
};

const popDetails = () => {
  return {
    type: POP_DETAILS,
  };
};

const clearSearch = () => {
  return {
    type: CLEAR_SEARCH,
  };
};

const clearDetails = () => {
  return {
    type: CLEAR_DETAILS,
  };
};

const clearEntries = () => {
  return {
    type: CLEAR_ENTRIES,
  };
};

const setServerInstance = (instance) => {
  return {
    type: SET_SERVER_INSTANCE,
    payload: instance
  };
}

const setCertificateType = (certType) => {
  return {
    type: SET_CERTIFICATE_TYPE,
    payload: certType
  };
}

const setCertificateLabel = (certType) => {
  return {
    type: SET_CERTIFICATE_LABEL,
    payload: certType
  };
}

const updateLogPageNum = (page) => {
  return {
    type: SET_LOGPAGE_NUM,
    payload: page
  };
}

const setRecentEntry = (id) => {
  return {
    type: SET_RECENT_ENTRY,
    payload: id
  };
}

const setSelectedAuthority = (authority) => {
  return {
    type: SET_SELECTED_AUTHORITY,
    payload: authority
  };
}

const setRequestMessage = (requestMessage) => {
  return {
    type: SET_REQUEST_MESSAGE,
    payload: requestMessage
  };
}

const setProcessingState = (processing) => {
  return {
    type: SET_PROCESSING_STATE,
    payload: processing
  };
}



export {
  updateSearch,
  updateEntries,
  pushDetails,
  popDetails,
  clearSearch,
  clearDetails,
  clearEntries,
  setServerInstance,
  setCertificateType,
  setCertificateLabel,
  updateLogPageNum,
  setRecentEntry,
  setSelectedAuthority,
  setRequestMessage,
  setProcessingState
};